import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Shared/Header';
import {
  AnnouncementIcon,
  DonationIcon,
  FacebookIcon,
  FamilyHistoryIcon,
  MissionaryIcon,
  ProgramIcon,
  ServeIcon,
  TempleIcon,
} from '../../icons';
import styles from './styles.module.scss';
import { Public, School } from '@mui/icons-material';

const HelpfulLinksPage = () => {
  const navigate = useNavigate();

  const pages = [
    {
      onClick: () => navigate(`/sacrament-program`),
      icon: <ProgramIcon />,
      name: 'Sacrament Program',
    },
    {
      onClick: () => navigate(`/announcements`),
      icon: <AnnouncementIcon />,
      name: 'Announcements',
    },
  ];

  const links = [
    {
      name: 'Ward Facebook Group',
      icon: <FacebookIcon />,
      href: `https://www.facebook.com/groups/1909751489230561/`,
    },
    {
      name: 'Temple Appointments',
      icon: <TempleIcon />,
      href: `https://www.churchofjesuschrist.org/temples/schedule/appointment?lang=eng`,
    },
    {
      name: 'Stake Temple Recommend Interviews',
      icon: <TempleIcon />,
      href: `https://calendar.google.com/calendar/appointments/schedules/AcZssZ1i_aMEu3jEUowuvSomyokqf6GtkOSM_DG76yAIOOf9Ew2b1q0lSacSD5_CyK2pDLjzfA630DT7`,
    },
    {
      name: 'Donations',
      icon: <DonationIcon />,
      href: `https://donations.churchofjesuschrist.org`,
    },
    {
      name: 'Volunteer and Serve',
      icon: <ServeIcon />,
      href: `https://www.churchofjesuschrist.org/serve?lang=eng`,
    },
    {
      name: 'FamilySearch.org',
      icon: <FamilyHistoryIcon />,
      href: `https://www.familysearch.org`,
    },
    {
      name: 'Missionary Portal',
      icon: <MissionaryIcon />,
      href: `https://missionary.churchofjesuschrist.org/portal/non-missionary?lang=eng`,
    },
    {
      name: 'Institute',
      icon: <School />,
      href: `https://myinstitute.churchofjesuschrist.org/institute/29262/classes/1721985`,
    },
    {
      name: 'Ward Mission Plan',
      icon: <Public />,
      href: `https://docs.google.com/document/d/11G98QJ8HuMNHwWgd8GhGoAwV_ur92euw/edit?usp=sharing&ouid=101804644350744558017&rtpof=true&sd=true`,
    },
  ];

  return (
    <>
      <div className={styles.helpfulLinks}>
        <div className={styles.heroBanner}>
          <img
            src='/images/helpful-links-hero.webp'
            alt='Emergency Preparedness Folder'
            className={styles.heroImage}
          />
        </div>
        <Header title='Helpful Links' direction='row' type='page' underlined />

        {pages.map((page, index) => {
          return (
            <Button
              key={index}
              onClick={page.onClick}
              className={styles.link}
              startIcon={page.icon}
            >
              {page.name}
            </Button>
          );
        })}

        {links.map((link, index) => {
          return (
            <Button
              href={link.href}
              target='_blank'
              key={index}
              className={styles.link}
              startIcon={link.icon}
            >
              {link.name}
            </Button>
          );
        })}
      </div>
    </>
  );
};

export default HelpfulLinksPage;
